export enum UserStatusEnum {
  STATUS_ACTIVE = 'active',
  STATUS_INACTIVE = 'inactive',
  STATUS_DELETED = 'deleted',
  STATUS_PENDING = 'pending',
  STATUS_REVIEW = 'review',
  STATUS_DECLINED = 'declined',
  STATUS_BLOCKED = 'blocked',
}
